<template>
    <v-dialog
        v-model="dialogVisible"
        fullscreen
        hide-overlay
        :retain-focus="false"
        persistent
        transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
            <v-btn 
                class="btnDetails"
                v-bind="attrs"
                v-on="on" 
                icon    
                x-large
                dark
                text
                @click="dialogVisible = true"
                style="background-color: transparent;"
                >
                  <v-icon color="primary">mdi-border-color</v-icon>
            </v-btn>
        </template>
        <v-card>
          <v-toolbar
              dark
              color="secondary">
              <v-btn icon dark class="btn btn-primary" @click="closeDialog">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            <v-toolbar-title>{{ $t('board.label.detailCategory.title') }}</v-toolbar-title>

            <template v-slot:extension>
              <v-tabs v-model="tab" align-with-title>
                <v-tabs-slider color="accent"></v-tabs-slider>

                <v-tab v-for="item in items" :key="item">
                  {{ item }}
                </v-tab>
              </v-tabs>
            </template> 

          </v-toolbar>

          <v-tabs-items v-model="tab" class="container mt-5">
              
            <v-tab-item>
              <div class="container mt-4">
                <detailsBoard
                :category="categoryProps"
                />
              </div>
            </v-tab-item>

            <v-tab-item>
              <listSubcategories
              :category="categoryProps"
              />
            </v-tab-item>

          </v-tabs-items>
  
        </v-card>
    </v-dialog>
  
</template>
  
<script>
  import detailsBoard from '@/views/categories_board/pages/detail_categories/components/form_detail_component.vue';
  import listSubcategories from '@/views/categories_board/pages/list_subcategories/list_subcategories_page.vue';
  import  EventBus  from '@/utils/event_bus.js';

  export default {
    
    name:"addCategoriesPage",
    components: {
      detailsBoard,
      listSubcategories
    },
    props: {
      categoryProps: {
        required: true
      },
    },
    data () {
      return {
        dialogVisible: false,
        tab: null,
        items: [
          this.$t('label.tab'),
          this.$t('board.label.listSubCategory.title')
        ],
      }
    },

    async mounted() {
      EventBus.$on('reload-nameCategories', (name) => {
        this.categoryProps.nombre = name;
      });
    },

    methods: {
      closeDialog() {

        this.$store.commit('RESET_STATE');
        this.dialogVisible = false;
        
        window.location.reload();

      },
    },
  
    computed: { 
   
    }
  };
</script>
  
<style lang="css" scoped>
  .btnDetails .v-icon {
    color: #6E17A5;
    margin-bottom: 12px;
  }
</style>
  